import React from 'react';
import { Row, Col,DatePicker } from 'antd';

import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';

const TabRejectPayment = () => (
  <Row>
    <Col span={12}>
    <FormInput col xs={24} lg={24} name="parvalue" comcode="rejectreason" rules={[{ required: true }]}>
      <ParListSelect parcode="REJREASON" />
    </FormInput>
    </Col>
    <Col span={12}>
    <FormInput col xs={24} lg={24} name="pardate" comcode="rejectdate" rules={[{ required: true }]}>
      <DatePicker />
    </FormInput>
    </Col>
  </Row>
);

export default TabRejectPayment;
